var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCameraEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 16.226V16.5C17.25 17.2956 16.9339 18.0587 16.3713 18.6213C15.8087 19.1839 15.0456 19.5 14.25 19.5H4.5C3.70435 19.5 2.94129 19.1839 2.37868 18.6213C1.81607 18.0587 1.5 17.2956 1.5 16.5V7.5C1.5 6.70435 1.81607 5.94129 2.37868 5.37868C2.94129 4.81607 3.70435 4.5 4.5 4.5H14.25C15.0456 4.5 15.8087 4.81607 16.3713 5.37868C16.9339 5.94129 17.25 6.70435 17.25 7.5V7.774L20.084 5.588C21.07 4.828 22.5 5.53 22.5 6.776V17.224C22.5 18.47 21.07 19.173 20.084 18.412L17.25 16.226ZM4.5 6H14.25C14.6478 6 15.0294 6.15804 15.3107 6.43934C15.592 6.72064 15.75 7.10218 15.75 7.5V16.5C15.75 16.8978 15.592 17.2794 15.3107 17.5607C15.0294 17.842 14.6478 18 14.25 18H4.5C4.10218 18 3.72064 17.842 3.43934 17.5607C3.15804 17.2794 3 16.8978 3 16.5V7.5C3 7.10218 3.15804 6.72064 3.43934 6.43934C3.72064 6.15804 4.10218 6 4.5 6ZM17.25 14.331L21 17.224V6.776L17.25 9.669V14.331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCameraEnable);
export default __webpack_public_path__ + "static/media/Icons_Camera-enable.a77077de5928d8a34c70e29c50efc9f4.svg";
export { ForwardRef as ReactComponent };